module.exports = "<div>\n  <div class=\"sk-spinner sk-spinner-chasing-dots\">\n    <div class=\"sk-dot1\"></div>\n    <div class=\"sk-dot2\"></div>\n  </div>\n  <h2 style=\"text-align: center\" class=\"text-primary\">{{loadingMsg[number]}}</h2>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/spinnerSm/template.html
// module id = 1986
// module chunks = 0